import { API_URL } from 'src/constants';
import { fetch } from '../fetchWrapper/fetch';
import { IUser } from 'src/types';

export const reactivateUser = async ({ id }: IUser): Promise<boolean> => {
  const uri = `${API_URL}/admin/users/${id}/reactivate`;
  try {
    const response = await fetch(uri, { method: 'PUT' });
    return response.status === 204;
  } catch (e) {
    throw new Error(e.message);
  }
};
